import { LanguageDTO } from "dev-corize-api-client"; 

export class TranslationSettings
{
    constructor(translationId: string){ //TODO not this way to get customerdata
         
        this.translationId = translationId;
        this.languages = [];
        this.defaultLanguage ="";
    }
    public languages : Array<LanguageDTO> = new Array<LanguageDTO>() ;
    public defaultLanguage : string;
    public translationId : string;
    public requireAll :boolean = false; 
}